<template>
  <div
    class="modal fade"
    id="walletActivationModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="walletActivationModalLabel"
    aria-hidden="true"
    ref="modal"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content border-0 shadow-lg modal-gradient">
        <div
          class="modal-body p-5 text-center position-relative overflow-hidden"
        >
          <!-- Decorative Background Elements -->
          <div
            class="position-absolute top-0 start-0 w-100 h-100 bg-overlay"
          ></div>

          <div class="position-relative z-index-1">
            <div class="icon-box mb-4 mx-auto shadow-lg">
              <i class="material-icons text-white text-5xl">verified_user</i>
            </div>

            <h3
              class="text-white font-weight-bolder mb-3 text-uppercase tracking-wide"
            >
              Ativar Carteira do Sistema
            </h3>

            <p class="text-white opacity-8 mb-4 mx-auto" style="max-width: 90%">
              Você está prestes a usar o modo de
              <strong>Carteira do Sistema</strong>. Nesse modelo você pode criar
              campanhas <strong>gratuitas</strong> e só é cobrado quando vender,
              além de conseguir usufruir de nossa carteira integrado direto no
              sistema.
            </p>

            <p
              class="text-white text-xs opacity-6 mb-5 mx-auto"
              style="max-width: 80%"
            >
              Ah, lembrando: ao ativar essa função, para desativar depois, se
              você quiser, basta entrar em contato conosco.
            </p>

            <div class="d-flex justify-content-center gap-3">
              <button
                type="button"
                class="btn btn-outline-white font-weight-bold px-4"
                @click="closeModal"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="btn btn-white text-primary font-weight-bolder px-4 shadow-lg transform-hover"
                @click="confirmActivation"
              >
                Sim, Ativar!
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";

export default {
  name: "WalletActivationModal",
  emits: ["close", "confirm"],
  data() {
    return {
      modalInstance: null,
    };
  },
  mounted() {
    this.modalInstance = new Modal(this.$refs.modal, {
      backdrop: "static",
      keyboard: false,
    });
  },
  methods: {
    show() {
      this.modalInstance.show();
    },
    closeModal() {
      this.modalInstance.hide();
      this.$emit("close");
    },
    confirmActivation() {
      this.modalInstance.hide();
      this.$emit("confirm");
    },
  },
};
</script>

<style scoped>
.modal-gradient {
  background: linear-gradient(135deg, #661cb0 0%, #a64bf4 100%);
  border-radius: 20px;
}

.bg-overlay {
  background-image: url("https://www.transparenttextures.com/patterns/cubes.png"),
    radial-gradient(
      circle at 20% 20%,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 20%
    ),
    radial-gradient(
      circle at 80% 80%,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 20%
    );
  opacity: 0.2;
}

.icon-box {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
}

.transform-hover {
  transition: all 0.3s ease;
}
.transform-hover:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2) !important;
}

.text-5xl {
  font-size: 3rem;
}

.tracking-wide {
  letter-spacing: 1px;
}

.btn-outline-white {
  border: 1px solid rgba(255, 255, 255, 0.5);
  color: white;
}
.btn-outline-white:hover {
  background: rgba(255, 255, 255, 0.1);
}

.btn-white {
  background: white;
  color: #661cb0;
}
</style>
